import React from 'react';

const AccountFormHeader = () => {
    return (<div className="form-header">
        <div className="form-header-logo" ></div>
    </div>);
}

export default AccountFormHeader